import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/categories';

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group bg-background-50 rounded-xl border border-background-200/60 p-6 transition-all duration-300 hover:border-primary-200/60 block"
    >
      <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
        <i className={`${category.icon} text-xl`}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-950 mb-2 whitespace-nowrap">
        {category.name}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
        {category.description}
      </p>
      <span className="text-xs text-primary-600 font-medium whitespace-nowrap">
        {category.articleCount} 篇文章 →
      </span>
    </Link>
  );
}